import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import DeepLinkModal from './DeepLinkModal';

const App = props => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <DeepLinkModal
      isOpen={isOpen}
      externalLinksOnly={props.externalLinksOnly}
      hasSSOMethod={props.hasSSOMethod}
      messageTemplateType={props.messageTemplateType}
      closeModal={() => {
        setIsOpen(false);
        props.onClose();
      }}
      confirmLink={link => {
        setIsOpen(false);
        props.onFinish(link);
      }}
    />
  );
}

App.propTypes = {
  onClose: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
  externalLinksOnly: PropTypes.bool.isRequired,
  hasSSOMethod: PropTypes.bool.isRequired,
  messageTemplateType: PropTypes.string,
};

export default hot(module)(App);
